import { ReviewTab, TabItem } from '../types';

import { styles } from './UiReviewTabsBase.styles';

export interface UiReviewTabsBaseProps {
  tabs: TabItem[];
  activeTabId: ReviewTab;
  onTabChange?: (tabId: ReviewTab) => void;
  className?: string;
  titleClassName?: string;
}

export function UiReviewTabsBase({
  tabs,
  activeTabId,
  onTabChange,
  className,
  titleClassName
}: UiReviewTabsBaseProps) {
  const slots = styles();

  return (
    <div className={slots.base({ className })}>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={slots.tab({
            active: tab.id === activeTabId
          })}
          onClick={() => onTabChange?.(tab.id)}
        >
          <span
            className={`${slots.title({ className: titleClassName })} ${tab.count === 0 && slots.emptyTitleClass()}`}
          >
            {tab.count > 0 ? tab.title : tab.emptyTitle}
          </span>
        </button>
      ))}
    </div>
  );
}
